var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraghandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50033 10.8327C3.96056 10.8327 4.33366 10.4596 4.33366 9.99935C4.33366 9.53911 3.96056 9.16602 3.50033 9.16602C3.04009 9.16602 2.66699 9.53911 2.66699 9.99935C2.66699 10.4596 3.04009 10.8327 3.50033 10.8327Z",
    fill: "#0D0D12",
    stroke: "#0D0D12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50033 5.00065C3.96056 5.00065 4.33366 4.62756 4.33366 4.16732C4.33366 3.70708 3.96056 3.33398 3.50033 3.33398C3.04009 3.33398 2.66699 3.70708 2.66699 4.16732C2.66699 4.62756 3.04009 5.00065 3.50033 5.00065Z",
    fill: "#0D0D12",
    stroke: "#0D0D12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50033 16.6667C3.96056 16.6667 4.33366 16.2936 4.33366 15.8333C4.33366 15.3731 3.96056 15 3.50033 15C3.04009 15 2.66699 15.3731 2.66699 15.8333C2.66699 16.2936 3.04009 16.6667 3.50033 16.6667Z",
    fill: "#0D0D12",
    stroke: "#0D0D12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50033 10.8327C8.96056 10.8327 9.33366 10.4596 9.33366 9.99935C9.33366 9.53911 8.96056 9.16602 8.50033 9.16602C8.04009 9.16602 7.66699 9.53911 7.66699 9.99935C7.66699 10.4596 8.04009 10.8327 8.50033 10.8327Z",
    fill: "#0D0D12",
    stroke: "#0D0D12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50033 5.00065C8.96056 5.00065 9.33366 4.62756 9.33366 4.16732C9.33366 3.70708 8.96056 3.33398 8.50033 3.33398C8.04009 3.33398 7.66699 3.70708 7.66699 4.16732C7.66699 4.62756 8.04009 5.00065 8.50033 5.00065Z",
    fill: "#0D0D12",
    stroke: "#0D0D12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50033 16.6667C8.96056 16.6667 9.33366 16.2936 9.33366 15.8333C9.33366 15.3731 8.96056 15 8.50033 15C8.04009 15 7.66699 15.3731 7.66699 15.8333C7.66699 16.2936 8.04009 16.6667 8.50033 16.6667Z",
    fill: "#0D0D12",
    stroke: "#0D0D12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraghandle);
export default __webpack_public_path__ + "static/media/draghandle.05b3d2288eb10c5cf950f9158ffd90f8.svg";
export { ForwardRef as ReactComponent };